import { render, staticRenderFns } from "./IdentityOCR.vue?vue&type=template&id=13e28552&scoped=true&"
import script from "./IdentityOCR.vue?vue&type=script&lang=js&"
export * from "./IdentityOCR.vue?vue&type=script&lang=js&"
import style0 from "./IdentityOCR.vue?vue&type=style&index=0&id=13e28552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e28552",
  null
  
)

export default component.exports